module.exports = __webpack_public_path__ + "img/undraw_completed.55f1e082.svg";